import React from 'react';
import styles from './NotFoundPage.module.scss'; // Create this SCSS module

const NotFoundPage: React.FC = () => {
  const handleBackToHome = () => {
    window.history.back();
  };

  return (
    <div className={styles.page}>
      <img src='/assets/404-logo.png' alt='Page Not Found' className={styles.errorImage} />
      <h1 className={styles.title}>Page Not Found</h1>
      <div className={styles.buttonContainer}>
        <button onClick={handleBackToHome} className={styles.homeButton}>
          Back to Home
        </button>
      </div>
    </div>
  );
};

export default NotFoundPage;
